import i18n from '@/utils/i18n'

/** system/info payment_method: 0=계좌+테더, 1=테더만, 2=계좌만, 3=입출금 비활성 */
export const PAYMENT_METHOD_BOTH = 0
export const PAYMENT_METHOD_TETHER_ONLY = 1
export const PAYMENT_METHOD_BANK_ONLY = 2
export const PAYMENT_METHOD_NONE = 3

export function resolvePaymentMethod (siteInfo) {
  const raw = siteInfo && siteInfo.payment_method != null
    ? Number(siteInfo.payment_method)
    : PAYMENT_METHOD_BOTH
  if (raw === PAYMENT_METHOD_TETHER_ONLY) return PAYMENT_METHOD_TETHER_ONLY
  if (raw === PAYMENT_METHOD_BANK_ONLY) return PAYMENT_METHOD_BANK_ONLY
  if (raw === PAYMENT_METHOD_NONE) return PAYMENT_METHOD_NONE
  return PAYMENT_METHOD_BOTH
}

export function isPaymentMethodEnabled (paymentMethod) {
  return Number(paymentMethod) !== PAYMENT_METHOD_NONE
}

export function isSiteWalletEnabled (siteInfo) {
  return isPaymentMethodEnabled(resolvePaymentMethod(siteInfo))
}

const WALLET_SIDE_MENU_KEYS = new Set(['deposit', 'withdraw'])

export function filterSideMenuByWallet (items, walletEnabled) {
  if (!Array.isArray(items)) return []
  if (walletEnabled) return items
  return items.filter(item => !WALLET_SIDE_MENU_KEYS.has(item.key))
}

export function paymentMethodAllowsBank (paymentMethod) {
  return paymentMethod === PAYMENT_METHOD_BOTH || paymentMethod === PAYMENT_METHOD_BANK_ONLY
}

export function paymentMethodAllowsTether (paymentMethod) {
  return paymentMethod === PAYMENT_METHOD_BOTH || paymentMethod === PAYMENT_METHOD_TETHER_ONLY
}

export function normalizeWalletTab (paymentMethod, currentTab) {
  const bank = paymentMethodAllowsBank(paymentMethod)
  const tether = paymentMethodAllowsTether(paymentMethod)
  if (currentTab === 'bank' && bank) return 'bank'
  if (currentTab === 'tether' && tether) return 'tether'
  if (bank) return 'bank'
  if (tether) return 'tether'
  return 'bank'
}

export function canSelectWalletTab (paymentMethod, tab) {
  if (tab === 'bank') return paymentMethodAllowsBank(paymentMethod)
  if (tab === 'tether') return paymentMethodAllowsTether(paymentMethod)
  return false
}

export function getDepositSubtitle (paymentMethod) {
  if (paymentMethod === PAYMENT_METHOD_TETHER_ONLY) {
    return i18n.t('payment.depositSubtitleTether')
  }
  if (paymentMethod === PAYMENT_METHOD_BANK_ONLY) {
    return i18n.t('payment.depositSubtitleBank')
  }
  return i18n.t('payment.depositSubtitleBoth')
}

export function getWithdrawSubtitle (paymentMethod) {
  if (paymentMethod === PAYMENT_METHOD_TETHER_ONLY) {
    return i18n.t('payment.withdrawSubtitleTether')
  }
  if (paymentMethod === PAYMENT_METHOD_BANK_ONLY) {
    return i18n.t('payment.withdrawSubtitleBank')
  }
  return i18n.t('payment.withdrawSubtitleBoth')
}
